import {connect} from 'react-redux';
import TabShared from './TabShared';
import {getStep9Grid} from '../../actions/steps/getStep9Grid';
import {setStep9Page} from '../../actions/steps/setStep9Page';
import {getStep9GridForExcel} from '../../actions/steps/getStep9GridForExcel';
import {saveSharedRow} from '../../actions/steps/step9SaveRow';
import {showLittlePopup} from '../../actions/step9LittlePopup';
import {actions as A} from '../../constants/actions';
import {api} from '../../constants/api';
import {saveTab3Filters} from '../../actions/step9SaveTabFilters';

const mapStateToProps = ({
                           step9Shared: {list, page, totalPages, totalResultCount, loading},
                           step9SharedForExcel: {listForExcel},
                           step9Filters: {tab3}
                         }) => ({
  listForExcel,
  list,
  page,
  totalPages,
  totalResultCount,
  previousFilters: tab3,
  loading
});

export default connect(
  mapStateToProps,
  {
    getStep9Grid: getStep9Grid({
      actions: {
        pending: A.GET_STEP_9_GIRD_SHARED_DATA,
        success: A.GET_STEP_9_GIRD_SHARED_DATA_SUCCESS,
        failure: A.GET_STEP_9_GIRD_SHARED_DATA_FAILURE,
        setPage: A.SET_STEP_9_GIRD_SHARED_DATA_PAGE,
      },
      api: api.GET_STEP_9_GIRD_SHARED_DATA,
  }),
    setStep9Page: setStep9Page(A.SET_STEP_9_GIRD_SHARED_DATA_PAGE),
    getStep9GridSharedForExcel: getStep9GridForExcel({
      actions: {
        pending: A.GET_STEP_9_GRID_SHARED_DATA_FOR_EXCEL,
        success: A.GET_STEP_9_GRID_SHARED_DATA_FOR_EXCEL_SUCCESS,
        failure: A.GET_STEP_9_GRID_SHARED_DATA_FOR_EXCEL_FAILURE,
      },
      api: api.GET_STEP_9_GRID_SHARED_DATA_FOR_EXCEL,
    }),
    saveRow: saveSharedRow,
    saveFilters: saveTab3Filters,
    showLittlePopup,
  }
)(TabShared);
